let glo;
if (window) {
  glo = window;
} else {
  glo = global;
}
export default glo;
